/* Cart drawer presentation layer.

   theme.js owns the cart data and rewrites [data-cart-items] after every
   change. Rather than fork that logic, this watches its output and reshapes
   it: price moves above the quantity box, the linear progress bar is mirrored
   onto a ring, and the upsell rail hides anything already in the cart.

   Nothing here invents prices or claims; it only rearranges what theme.js and
   Liquid already rendered. */
(function () {
  'use strict';

  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  var items   = drawer.querySelector('[data-cart-items]');
  var bar     = drawer.querySelector('[data-cart-ship-bar]');
  var ring    = drawer.querySelector('[data-cart-ship-ring]');
  var shipTxt = drawer.querySelector('[data-cart-ship-text]');
  var upsell  = drawer.querySelector('[data-cart-upsell]');
  var CIRC    = 97.39;

  /* Plain string work, no regex: this file is authored inside a GraphQL block
     string, where backslash escapes would not survive the round trip. */
  function handleOf(href) {
    if (!href) return '';
    var s = String(href);
    var i = s.indexOf('/products/');
    if (i === -1) return '';
    var rest = s.slice(i + 10);
    var cut = rest.length;
    var stops = ['?', '#', '/'];
    for (var k = 0; k < stops.length; k++) {
      var p = rest.indexOf(stops[k]);
      if (p !== -1 && p < cut) cut = p;
    }
    return rest.slice(0, cut);
  }

  /* theme.js renders .cart-item__prices as a sibling of .cart-item__info.
     Dore & Rose stack it with the rest of the text, above the stepper. */
  function reflowItems() {
    if (!items) return;
    var rows = items.querySelectorAll('.cart-item');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var info = row.querySelector('.cart-item__info');
      var prices = row.querySelector('.cart-item__prices');
      var controls = row.querySelector('.cart-item__controls');
      if (!info || !prices) continue;
      if (prices.parentNode === info && (!controls || prices.nextElementSibling === controls)) continue;
      if (controls) info.insertBefore(prices, controls);
      else info.appendChild(prices);
    }
  }

  /* Rewrites are idempotent: the second pass recomputes the same string and
     skips the write, so observing our own output cannot loop. */
  function syncShip() {
    var pct = bar ? (parseFloat(String(bar.style.width || '0')) || 0) : 0;
    if (pct > 100) pct = 100;
    if (ring) ring.style.strokeDashoffset = String(CIRC - (CIRC * pct) / 100);

    if (!shipTxt) return;
    var strong = shipTxt.querySelector('strong');
    var want;
    if (strong && strong.textContent.trim()) {
      want = 'You are only <strong>' + strong.textContent.trim() + '</strong> away from free shipping';
    } else if (pct >= 100) {
      want = '<span class="cart-ship__done">You have unlocked free shipping</span>';
    } else {
      return;
    }
    if (shipTxt.innerHTML !== want) shipTxt.innerHTML = want;
  }

  function syncUpsell() {
    if (!upsell || !items) return;

    var inCart = {};
    var links = items.querySelectorAll('.cart-item__title[href]');
    for (var i = 0; i < links.length; i++) {
      var h = handleOf(links[i].getAttribute('href'));
      if (h) inCart[h] = true;
    }

    var cards = upsell.querySelectorAll('.cart-up__card');
    var shown = 0;
    for (var j = 0; j < cards.length; j++) {
      var card = cards[j];
      var t = card.querySelector('.cart-up__title');
      var ch = handleOf(t && t.getAttribute('href'));
      var hide = !!(ch && inCart[ch]);
      card.hidden = hide;
      if (!hide) shown++;
    }

    var hasItems = items.querySelector('.cart-item') !== null;
    upsell.hidden = !hasItems || shown === 0;
  }

  function syncAll() { reflowItems(); syncUpsell(); }

  if (window.MutationObserver) {
    if (items) new MutationObserver(syncAll).observe(items, { childList: true, subtree: true });
    if (bar) new MutationObserver(syncShip).observe(bar, { attributes: true, attributeFilter: ['style'] });
    if (shipTxt) new MutationObserver(syncShip).observe(shipTxt, { childList: true, subtree: true, characterData: true });
  }

  /* upsell interactions */
  drawer.addEventListener('click', function (e) {
    var open = e.target.closest('[data-up-open]');
    if (open) {
      e.preventDefault();
      var card = open.closest('.cart-up__card');
      var sizes = card && card.querySelector('[data-up-sizes]');
      if (sizes) {
        sizes.hidden = !sizes.hidden;
        open.textContent = sizes.hidden ? 'Add to cart' : 'Pick a size';
      }
      return;
    }

    var add = e.target.closest('[data-up-add]');
    if (!add) return;
    e.preventDefault();
    var id = add.getAttribute('data-up-add');
    if (!id) return;

    var card2 = add.closest('.cart-up__card');
    var btn = card2 && card2.querySelector('.cart-up__btn');
    if (btn) btn.classList.add('is-busy');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { alert(res.description || res.message); return; }
        var sizes2 = card2 && card2.querySelector('[data-up-sizes]');
        if (sizes2) sizes2.hidden = true;
        if (window.theme && window.theme.refreshCart) return window.theme.refreshCart();
      })
      .catch(function () {})
      .finally(function () {
        if (btn) { btn.classList.remove('is-busy'); btn.textContent = 'Add to cart'; }
      });
  });

  syncAll();
  syncShip();
  document.addEventListener('DOMContentLoaded', function () { syncAll(); syncShip(); });
})();